const MOCK_AUTH_KEY = 'dcs_mock_auth_user';
const MOCK_MODE_KEY = 'dcs_mock_mode';

export const MOCK_LOGIN_USERNAME = 'admin';
export const MOCK_LOGIN_PASSWORD = 'password';
export const isMockAuthEnabled = () => (
    import.meta.env.VITE_ENABLE_MOCK_AUTH !== 'false' &&
    import.meta.env.VITE_ENABLE_DEMO_MODE !== 'false'
);

export type MockAuthUser = {
    id: number;
    email: string;
    firstName: string;
    lastName: string;
    role: 'admin';
    access_token: string;
};

export const mockUser: MockAuthUser = {
    id: 1,
    email: 'admin@local.test',
    firstName: 'Local',
    lastName: 'Admin',
    role: 'admin',
    access_token: 'mock-local-token',
};

export const isMockModeActive = () => {
    if (!isMockAuthEnabled()) return false;
    return window.localStorage.getItem(MOCK_MODE_KEY) === 'true';
};

export const enableMockMode = () => {
    if (!isMockAuthEnabled()) return false;

    window.localStorage.setItem(MOCK_MODE_KEY, 'true');
    window.localStorage.setItem(MOCK_AUTH_KEY, JSON.stringify(mockUser));
    return true;
};

export const disableMockMode = () => {
    window.localStorage.removeItem(MOCK_MODE_KEY);
    window.localStorage.removeItem(MOCK_AUTH_KEY);
};

export const getMockUser = (): MockAuthUser | null => {
    if (!isMockModeActive()) return null;

    try {
        const rawUser = window.localStorage.getItem(MOCK_AUTH_KEY);
        return rawUser ? JSON.parse(rawUser) : null;
    } catch {
        return null;
    }
};

export const isMockAuthenticated = () => Boolean(getMockUser());

export const mockLogin = (username: string, password: string) => {
    if (!isMockAuthEnabled()) {
        return false;
    }

    if (username.trim() !== MOCK_LOGIN_USERNAME || password !== MOCK_LOGIN_PASSWORD) {
        return false;
    }

    window.localStorage.setItem(MOCK_AUTH_KEY, JSON.stringify(mockUser));
    window.localStorage.setItem(MOCK_MODE_KEY, 'true');
    return true;
};

export const mockLogout = () => {
    disableMockMode();
};
